// import { Theme } from '@mui/material/styles';
import { Box } from '@mui/material';
import Profile from './Profile';
import Customization from './Customization';

const HeaderContent = () => {
  // const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  return (
    <>
      <Box sx={{ width: '100%', ml: 1 }} />
      <Customization />
      <Profile />
    </>
  );
};

export default HeaderContent;
